import { reactive } from 'vue';

// Where a signed-out visitor goes when a page needs an account: the log-in form for
// someone who has had an account on this browser (the gp_has_account marker), the
// sign-up form for everyone else. Unreadable storage counts as no account.
//
// The router's sign-in guard (booking links), CheckoutView and every "Book a POD"
// link (bookPodRoute below) send visitors here, so they can't drift apart. JoinView
// reads ?show= in mounted(). hasAccount defaults to the marker as it is right now.
export function signedOutJoinRoute(hasAccount = hasAccountMarker()) {
  return { name: 'join', query: { show: hasAccount ? 'login' : 'join' } };
}

function hasAccountMarker() {
  try {
    return localStorage.getItem('gp_has_account') === '1';
  } catch (e) {
    return false; // storage unavailable: sign-up form
  }
}

// Sign-in state behind every "Book a POD" link. The nav (App.vue) and the page CTAs
// both read it, so their hrefs always match: Lighthouse flags links with the same
// text and different hrefs. App.vue calls readBookPodAuth() at mount and on
// gp-auth-change (startSession fires it when a dead token signs the member out).
export const bookPodAuth = reactive({ authed: false, hasAccount: false });

// Skipped in the prerender pass, so the saved HTML always has the sign-up link.
// Unreadable storage counts as signed out.
export function readBookPodAuth() {
  if (window.__PRERENDER__) return;
  try {
    bookPodAuth.authed = !!sessionStorage.getItem('userSession');
  } catch (e) {
    bookPodAuth.authed = false;
  }
  bookPodAuth.hasAccount = hasAccountMarker();
}

// "Book a POD": /book when signed in, otherwise straight to the join form the
// sign-in guard would redirect /book to.
export function bookPodRoute() {
  return bookPodAuth.authed ? '/book' : signedOutJoinRoute(bookPodAuth.hasAccount);
}
